import { render, staticRenderFns } from "./DropdownChild.vue?vue&type=template&id=9e38e092&"
import script from "./DropdownChild.vue?vue&type=script&lang=js&"
export * from "./DropdownChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports